<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TRztUk/images/9780316253598.jpg?1733085655290" alt="This image is the cover for the book Breaking Point"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Breaking Point
      </h1>
      <p class="bookDescription body article font2">
        <p>In this collection of suspenseful tales in which fantasies, murderous dreams and half-forgotten worlds are exposed, Daphne du Maurier explores the boundaries of reality and imagination. Her characters are caught at those moments when the delicate link between reason and emotion has been stretched to the breaking point. Often chilling, sometimes poignant, these stories display the full range of Daphne du Maurier's considerable talent. <br/><br/> "The appeal of romance and the clash of highly-charged emotions."-<i>New York Herald-Tribune</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Daphne Du Maurier
      </h2>
      
      <p class="authorDescription body article"><B>Daphne du Maurier</B> (1907-89) was born in London, the daughter of the actor Sir Gerald du Maurier and granddaughter of the author and artist George du Maurier. Her first novel, <I>The Loving Spirit</I>, was published in 1931, but it would be her fifth novel, <I>Rebecca</I>, that made her one of the most popular authors of her day. <br><br> Besides novels, du Maurier wrote plays, biographies, and several collections of short fiction. Many of her works were made into films, including <I>Rebecca</I>, <I>Jamaica Inn</I>, <I>My Cousin Rachel</I>, "Don't Look Now," and "The Birds." She lived most of her life in Cornwall, and was made a Dame of the British Empire in 1969.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Little, Brown and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4f4b1507